//#region Styles
import { Container } from "./styles";
//#endregion
//#region Components
import CustomTableList from "components/CustomTableList/CustomTableList";
import TableListItem from "./TableListItem/TableListItem";
//#endregion
//#region Utils
import { HEADERS_TABLE_LIST } from "./constants";
//#endregion

const HistoryTable = ({
    changeHistory
}) => {
    return (
        <Container>
            <CustomTableList 
                minWidth="600px" 
                maxHeight="38vh"
                scrollColor="secondary"
                variant="secondary"
                headers={HEADERS_TABLE_LIST}>
                {changeHistory?.map((item, idx) => (
                    <TableListItem key={idx} {...item}/>
                ))}
            </CustomTableList>
        </Container>
    );
}

export default HistoryTable;